
import './App.css';
import { BrowserRouter,Switch , Route} from 'react-router-dom';
import Header from './Pages/Home/Header/Header';
import Home from './Pages/Home/Home/Home';
import About from './Pages/About/About';
import Project from './Pages/Project/Project';
import Contact from './Pages/Contact/Contact';
import Projects from './Pages/Projects/Projects';
import BuyingHouse from './Pages/Details/BuyingHouse';
import Gtour from './Pages/Details/Gtour';
import MacOs from './Pages/Details/MacOs';
import DentalCare from './Pages/Details/DentalCare';
import TopDeveloper from './Pages/Details/TopDeveloper';
import Blogs from './Pages/Blogs/Blogs';
import Footer from './Pages/Shared/Footer/Footer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Header></Header>
      <Switch>
    <Route exact path="/">
     <Home></Home>
    </Route>
    <Route exact path="/home">
    <Home></Home>
    </Route>
    <Route exact path="/about">
     <About></About>
    </Route>
    <Route path="/project">
    <Project></Project>
    </Route>
    <Route path="/projects">
    <Projects></Projects>
    </Route>
    <Route path="/contact">
    <Contact></Contact>
    </Route>
    <Route path="/buyingHouse">
      <BuyingHouse></BuyingHouse>
    </Route>
    <Route path="/gTour">
    <Gtour></Gtour>
    </Route>
    <Route path="/macOs">
      <MacOs></MacOs>
    </Route>
    <Route path="/dentalCare">
    <DentalCare></DentalCare>
    </Route>
    <Route path="/topDeveloper">
    <TopDeveloper></TopDeveloper>
    </Route>
    <Route path="/blogs">
      <Blogs></Blogs>
    </Route>
      </Switch>
      <Footer></Footer>
      </BrowserRouter>
    </div>
  );
}

export default App;
